import { createElementVNode as _createElementVNode, openBlock as _openBlock, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-1 overflow-y-auto bg-slate-50 p-5"
};
import WealthOperationApplyBusinessDetail from './WealthOperationApplyBusinessDetail.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'WealthOperationApplyDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    applyId: {
      type: [Number, String],
      default: null
    },
    approvalInstanceId: {
      type: [Number, String],
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    function closeModal() {
      emit('update:modelValue', false);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.modelValue,
        size: "5xl",
        "z-index": 80,
        onClose: closeModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "flex shrink-0 items-center justify-between border-b border-slate-200 px-6 py-4"
        }, [_cache[1] || (_cache[1] = _createElementVNode("div", null, [_createElementVNode("h3", {
          class: "text-lg font-semibold text-slate-900"
        }, "资金申请业务详情"), _createElementVNode("p", {
          class: "mt-0.5 text-xs text-slate-500"
        }, "审批中心内查看对应财富资金申请、批次明细和附件。")], -1)), _createElementVNode("button", {
          type: "button",
          class: "p-1.5 text-slate-400 hover:text-slate-600",
          onClick: closeModal
        }, [...(_cache[0] || (_cache[0] = [_createElementVNode("svg", {
          class: "h-5 w-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_1, [_createVNode(WealthOperationApplyBusinessDetail, {
          "apply-id": __props.applyId,
          "approval-instance-id": __props.approvalInstanceId
        }, null, 8, ["apply-id", "approval-instance-id"])])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};